import React from "react";
import "../template-file-css/document-file-template.css";

export const NBT_SomaticSymptomAdultPatient = ({ itemsRef, showErrorFor }) => {

    return (
        <form id='NBT_SomaticSymptomAdultPatient' className='file-pdf-document'>
            <div className='file-template'>

            <table>
                    <tr>
                        <td className="w-375">
                            <span className="eleHeader">Age:</span>
                            <input type="text" name="txtAge" id="txtAge" className="add-only" />
                        </td>
                        <td className="w-375">
                            <span className="eleHeader">Date:</span>
                            <input type="date" name="txtDate" id="txtDate" className="add-only" />
                        </td>
                    </tr>
                </table>
                <p>
                    If the measure is being completed by an informant, what is your relationship with the individual receiving care?
                    <input type="text" name="txtReceivingCare" id="txtReceivingCare" className="add-only" />
                </p>
                <p>
                    In a typical week, approximately how much time do you spend with the individual receiving care?
                    <input type="text" name="txtReceivingCare1" id="txtReceivingCare1" className="add-only" />
                    hours/week
                </p>
                <p>
                    <strong>Instructions:</strong> On the DSM-5 Level 1 cross-cutting questionnaire that you just completed, you indicated that during the
                    past 2 weeks you (the individual receiving care) have been bothered by "unexplained aches and pains", and/or "feeling
                    that your illnesses are not being taken seriously enough" at a mild or greater level of severity. The questions below ask
                    about these feelings in more detail and especially how often you (the individual receiving care) have been bothered by
                    a list of symptoms <strong>during the past 7 days. Please respond to each item by marking (&#10003; or x) one box per row.</strong>
                </p>
                <table>
                    <tr>
                        <td className="w-60 text-align:right"><b>Clinician Use</b></td>
                    </tr>
                    <tr>
                        <td className="w-300"><span className="eleHeader">In the past SEVEN (7) DAYS....</span></td>
                        <td className="w-60"><span className="eleHeader">Never</span></td>
                        <td className="w-60"><span className="eleHeader">Rarely</span></td>
                        <td className="w-100"><span className="eleHeader">Sometimes</span></td>
                        <td className="w-60"><span className="eleHeader">Often</span></td>
                        <td className="w-60"><span className="eleHeader">Always</span></td>
                        <td className="w-100"><span className="eleHeader">Item Score</span></td>
                    </tr>
                    <tr>
                        <td className="w-300"><b>1.</b> Stomach pain</td>
                        <td className="w-60 text-center">
                            <input type="radio" id="rbStomachPainNever" name="rbStomachPain" className="add-only" value="Never" />&nbsp;
                            1
                        </td>
                        <td className="w-60 text-center">
                            <input type="radio" id="rbStomachPainRarely" name="rbStomachPain" className="add-only" value="Rarely" />&nbsp;
                            2
                        </td>
                        <td className="w-100 text-center">
                            <input type="radio" id="rbStomachPainSometimes" name="rbStomachPain" className="add-only" value="Sometimes" />&nbsp;
                            3
                        </td>
                        <td className="w-60 text-center">
                            <input type="radio" id="rbStomachPainOften" name="rbStomachPain" className="add-only" value="Often" />&nbsp;
                            4
                        </td>
                        <td className="w-60 text-center">
                            <input type="radio" id="rbStomachPainAlways" name="rbStomachPain" className="add-only" value="Always" />&nbsp;
                            5
                        </td>
                        <td className="w-100 text-center">
                            <input type="text" id="txtItemScore_StomachPain" name="txtItemScore_StomachPain" />
                        </td>
                    </tr>
                    <tr>
                        <td className="w-300"><b>2.</b> Back pain</td>
                        <td className="w-60 text-center">
                            <input type="radio" id="rbBachPainNever" name="rbBachPain" className="add-only" value="Never" />&nbsp;
                            1
                        </td>
                        <td className="w-60 text-center">
                            <input type="radio" id="rbBachPainRarely" name="rbBachPain" className="add-only" value="Rarely" />&nbsp;
                            2
                        </td>
                        <td className="w-100 text-center">
                            <input type="radio" id="rbBachPainSometimes" name="rbBachPain" className="add-only" value="Sometimes" />&nbsp;
                            3
                        </td>
                        <td className="w-60 text-center">
                            <input type="radio" id="rbBachPainOften" name="rbBachPain" className="add-only" value="Often" />&nbsp;
                            4
                        </td>
                        <td className="w-60 text-center">
                            <input type="radio" id="rbBachPainAlways" name="rbBachPain" className="add-only" value="Always" />&nbsp;
                            5
                        </td>
                        <td className="w-100 text-center">
                            <input type="text" id="txtItemScore_BackPain" name="txtItemScore_BackPain" />
                        </td>
                    </tr>
                    <tr>
                        <td className="w-300"><b>3.</b> Pain in your arms, legs, or joints (knees, hips, etc.)</td>
                        <td className="w-60 text-center">
                            <input type="radio" id="rbArmsPainNever" name="rbArmsPain" className="add-only" value="Never" />&nbsp;
                            1
                        </td>
                        <td className="w-60 text-center">
                            <input type="radio" id="rbArmsPainRarely" name="rbArmsPain" className="add-only" value="Rarely" />&nbsp;
                            2
                        </td>
                        <td className="w-100 text-center">
                            <input type="radio" id="rbArmsPainSometimes" name="rbArmsPain" className="add-only" value="Sometimes" />&nbsp;
                            3
                        </td>
                        <td className="w-60 text-center">
                            <input type="radio" id="rbArmsPainOften" name="rbArmsPain" className="add-only" value="Often" />&nbsp;
                            4
                        </td>
                        <td className="w-60 text-center">
                            <input type="radio" id="rbArmsPainAlways" name="rbArmsPain" className="add-only" value="Always" />&nbsp;
                            5
                        </td>
                        <td className="w-100 text-center">
                            <input type="text" id="txtItemScore_ArmsPain" name="txtItemScore_ArmsPain" />
                        </td>
                    </tr>
                    <tr>
                        <td className="w-300">
                            <b>4.</b> Menstrual cramps or other problems with your periods (WOMEN ONLY)
                        </td>
                        <td className="w-60 text-center">
                            <input type="radio" id="rbMenstrualCrampsNever" name="rbMenstrualCramps" className="add-only" value="Never" />&nbsp;
                            1
                        </td>
                        <td className="w-60 text-center">
                            <input type="radio" id="rbMenstrualCrampsRarely" name="rbMenstrualCramps" className="add-only" value="Rarely" />&nbsp;
                            2
                        </td>
                        <td className="w-100 text-center">
                            <input type="radio" id="rbMenstrualCrampsSometimes" name="rbMenstrualCramps" className="add-only" value="Sometimes" />&nbsp;
                            3
                        </td>
                        <td className="w-60 text-center">
                            <input type="radio" id="rbMenstrualCrampsOften" name="rbMenstrualCramps" className="add-only" value="Often" />&nbsp;
                            4
                        </td>
                        <td className="w-60 text-center">
                            <input type="radio" id="rbMenstrualCrampsAlways" name="rbMenstrualCramps" className="add-only" value="Always" />&nbsp;
                            5
                        </td>
                        <td className="w-100 text-center">
                            <input type="text" id="txtItemScore_MenstrualCramps" name="txtItemScore_MenstrualCramps" />
                        </td>
                    </tr>
                    <tr>
                        <td className="w-300"><b>5.</b> Headaches</td>
                        <td className="w-60 text-center">
                            <input type="radio" id="rbHeadachesNever" name="rbHeadaches" className="add-only" value="Never" />&nbsp;
                            1
                        </td>
                        <td className="w-60 text-center">
                            <input type="radio" id="rbHeadachesRarely" name="rbHeadaches" className="add-only" value="Rarely" />&nbsp;
                            2
                        </td>
                        <td className="w-100 text-center">
                            <input type="radio" id="rbHeadachesSometimes" name="rbHeadaches" className="add-only" value="Sometimes" />&nbsp;
                            3
                        </td>
                        <td className="w-60 text-center">
                            <input type="radio" id="rbHeadachesOften" name="rbHeadaches" className="add-only" value="Often" />&nbsp;
                            4
                        </td>
                        <td className="w-60 text-center">
                            <input type="radio" id="rbHeadachesAlways" name="rbHeadaches" className="add-only" value="Always" />&nbsp;
                            5
                        </td>
                        <td className="w-100 text-center">
                            <input type="text" id="txtItemScore_Headaches" name="txtItemScore_Headaches" />
                        </td>
                    </tr>
                    <tr>
                        <td className="w-300"><b>6.</b> Chest pain</td>
                        <td className="w-60 text-center">
                            <input type="radio" id="rbChestPainNever" name="rbChestPain" className="add-only" value="Never" />&nbsp;
                            1
                        </td>
                        <td className="w-60 text-center">
                            <input type="radio" id="rbChestPainRarely" name="rbChestPain" className="add-only" value="Rarely" />&nbsp;
                            2
                        </td>
                        <td className="w-100 text-center">
                            <input type="radio" id="rbChestPainSometimes" name="rbChestPain" className="add-only" value="Sometimes" />&nbsp;
                            3
                        </td>
                        <td className="w-60 text-center">
                            <input type="radio" id="rbChestPainOften" name="rbChestPain" className="add-only" value="Often" />&nbsp;
                            4
                        </td>
                        <td className="w-60 text-center">
                            <input type="radio" id="rbChestPainAlways" name="rbChestPain" className="add-only" value="Always" />&nbsp;
                            5
                        </td>
                        <td className="w-100 text-center">
                            <input type="text" id="txtItemScore_ChestPain" name="txtItemScore_ChestPain" />
                        </td>
                    </tr>
                    <tr>
                        <td className="w-300"><b>7.</b> Dizziness</td>
                        <td className="w-60 text-center">
                            <input type="radio" id="rbDizzinessNever" name="rbDizziness" className="add-only" value="Never" />&nbsp;
                            1
                        </td>
                        <td className="w-60 text-center">
                            <input type="radio" id="rbDizzinessRarely" name="rbDizziness" className="add-only" value="Rarely" />&nbsp;
                            2
                        </td>
                        <td className="w-100 text-center">
                            <input type="radio" id="rbDizzinessSometimes" name="rbDizziness" className="add-only" value="Sometimes" />&nbsp;
                            3
                        </td>
                        <td className="w-60 text-center">
                            <input type="radio" id="rbDizzinessOften" name="rbDizziness" className="add-only" value="Often" />&nbsp;
                            4
                        </td>
                        <td className="w-60 text-center">
                            <input type="radio" id="rbDizzinessAlways" name="rbDizziness" className="add-only" value="Always" />&nbsp;
                            5
                        </td>
                        <td className="w-100 text-center">
                            <input type="text" id="txtItemScore_Dizziness" name="txtItemScore_Dizziness" />
                        </td>
                    </tr>
                    <tr>
                        <td className="w-300"><b>8.</b> Fainting spells</td>
                        <td className="w-60 text-center">
                            <input type="radio" id="rbFaintingSpellsNever" name="rbFaintingSpells" className="add-only" value="Never" />&nbsp;
                            1
                        </td>
                        <td className="w-60 text-center">
                            <input type="radio" id="rbFaintingSpellsRarely" name="rbFaintingSpells" className="add-only" value="Rarely" />&nbsp;
                            2
                        </td>
                        <td className="w-100 text-center">
                            <input type="radio" id="rbFaintingSpellsSometimes" name="rbFaintingSpells" className="add-only" value="Sometimes" />&nbsp;
                            3
                        </td>
                        <td className="w-60 text-center">
                            <input type="radio" id="rbFaintingSpellsOften" name="rbFaintingSpells" className="add-only" value="Often" />&nbsp;
                            4
                        </td>
                        <td className="w-60 text-center">
                            <input type="radio" id="rbFaintingSpellsAlways" name="rbFaintingSpells" className="add-only" value="Always" />&nbsp;
                            5
                        </td>
                        <td className="w-100 text-center">
                            <input type="text" id="txtItemScore_FaintingSpells" name="txtItemScore_FaintingSpells" />
                        </td>
                    </tr>
                    <tr>
                        <td className="w-300"><b>9.</b> Feeling your heart pound or race</td>
                        <td className="w-60 text-center">
                            <input type="radio" id="rbHeartPoundNever" name="rbHeartPound" className="add-only" value="Never" />&nbsp;
                            1
                        </td>
                        <td className="w-60 text-center">
                            <input type="radio" id="rbHeartPoundRarely" name="rbHeartPound" className="add-only" value="Rarely" />&nbsp;
                            2
                        </td>
                        <td className="w-100 text-center">
                            <input type="radio" id="rbHeartPoundSometimes" name="rbHeartPound" className="add-only" value="Sometimes" />&nbsp;
                            3
                        </td>
                        <td className="w-60 text-center">
                            <input type="radio" id="rbHeartPoundOften" name="rbHeartPound" className="add-only" value="Often" />&nbsp;
                            4
                        </td>
                        <td className="w-60 text-center">
                            <input type="radio" id="rbHeartPoundAlways" name="rbHeartPound" className="add-only" value="Always" />&nbsp;
                            5
                        </td>
                        <td className="w-100 text-center">
                            <input type="text" id="txtItemScore_HeartPound" name="txtItemScore_HeartPound" />
                        </td>
                    </tr>
                    <tr>
                        <td className="w-300"><b>10.</b> Shortness of breath</td>
                        <td className="w-60 text-center">
                            <input type="radio" id="rbShortnessNever" name="rbShortness" className="add-only" value="Never" />&nbsp;
                            1
                        </td>
                        <td className="w-60 text-center">
                            <input type="radio" id="rbShortnessRarely" name="rbShortness" className="add-only" value="Rarely" />&nbsp;
                            2
                        </td>
                        <td className="w-100 text-center">
                            <input type="radio" id="rbShortnessSometimes" name="rbShortness" className="add-only" value="Sometimes" />&nbsp;
                            3
                        </td>
                        <td className="w-60 text-center">
                            <input type="radio" id="rbShortnessOften" name="rbShortness" className="add-only" value="Often" />&nbsp;
                            4
                        </td>
                        <td className="w-60 text-center">
                            <input type="radio" id="rbShortnessAlways" name="rbShortness" className="add-only" value="Always" />&nbsp;
                            5
                        </td>
                        <td className="w-100 text-center">
                            <input type="text" id="txtItemScore_Shortness" name="txtItemScore_Shortness" />
                        </td>
                    </tr>
                    <tr>
                        <td className="w-300"><b>11.</b> Pain or problems during sexual intercourse</td>
                        <td className="w-60 text-center">
                            <input type="radio" id="rbSexualIntercourseNever" name="rbSexualIntercourse" className="add-only" value="Never" />&nbsp;
                            1
                        </td>
                        <td className="w-60 text-center">
                            <input type="radio" id="rbSexualIntercourseRarely" name="rbSexualIntercourse" className="add-only" value="Rarely" />&nbsp;
                            2
                        </td>
                        <td className="w-100 text-center">
                            <input type="radio" id="rbSexualIntercourseSometimes" name="rbSexualIntercourse" className="add-only" value="Sometimes" />&nbsp;
                            3
                        </td>
                        <td className="w-60 text-center">
                            <input type="radio" id="rbSexualIntercourseOften" name="rbSexualIntercourse" className="add-only" value="Often" />&nbsp;
                            4
                        </td>
                        <td className="w-60 text-center">
                            <input type="radio" id="rbSexualIntercourseAlways" name="rbSexualIntercourse" className="add-only" value="Always" />&nbsp;
                            5
                        </td>
                        <td className="w-100 text-center">
                            <input type="text" id="txtItemScore_SexualIntercourse" name="txtItemScore_SexualIntercourse" />
                        </td>
                    </tr>
                    <tr>
                        <td className="w-300"><b>12.</b> Constipation, loose bowels, or diarrhea</td>
                        <td className="w-60 text-center">
                            <input type="radio" id="rbConstipationNever" name="rbConstipation" className="add-only" value="Never" />&nbsp;
                            1
                        </td>
                        <td className="w-60 text-center">
                            <input type="radio" id="rbConstipationRarely" name="rbConstipation" className="add-only" value="Rarely" />&nbsp;
                            2
                        </td>
                        <td className="w-100 text-center">
                            <input type="radio" id="rbConstipationSometimes" name="rbConstipation" className="add-only" value="Sometimes" />&nbsp;
                            3
                        </td>
                        <td className="w-60 text-center">
                            <input type="radio" id="rbConstipationOften" name="rbConstipation" className="add-only" value="Often" />&nbsp;
                            4
                        </td>
                        <td className="w-60 text-center">
                            <input type="radio" id="rbConstipationAlways" name="rbConstipation" className="add-only" value="Always" />&nbsp;
                            5
                        </td>
                        <td className="w-100 text-center">
                            <input type="text" id="txtItemScore_Constipation" name="txtItemScore_Constipation" />
                        </td>
                    </tr>
                    <tr>
                        <td className="w-300"><b>13.</b> Nausea, gas, or indigestion</td>
                        <td className="w-60 text-center">
                            <input type="radio" id="rbIndigestionNever" name="rbIndigestion" className="add-only" value="Never" />&nbsp;
                            1
                        </td>
                        <td className="w-60 text-center">
                            <input type="radio" id="rbIndigestionRarely" name="rbIndigestion" className="add-only" value="Rarely" />&nbsp;
                            2
                        </td>
                        <td className="w-100 text-center">
                            <input type="radio" id="rbIndigestionSometimes" name="rbIndigestion" className="add-only" value="Sometimes" />&nbsp;
                            3
                        </td>
                        <td className="w-60 text-center">
                            <input type="radio" id="rbIndigestionOften" name="rbIndigestion" className="add-only" value="Often" />&nbsp;
                            4
                        </td>
                        <td className="w-60 text-center">
                            <input type="radio" id="rbIndigestionAlways" name="rbIndigestion" className="add-only" value="Always" />&nbsp;
                            5
                        </td>
                        <td className="w-100 text-center">
                            <input type="text" id="txtItemScore_Indigestion" name="txtItemScore_Indigestion" />
                        </td>
                    </tr>
                    <tr>
                        <td className="w-300"><b>14.</b> Feeling tired or having low energy</td>
                        <td className="w-60 text-center">
                            <input type="radio" id="rbLowEnergyNever" name="rbLowEnergy" className="add-only" value="Never" />&nbsp;
                            1
                        </td>
                        <td className="w-60 text-center">
                            <input type="radio" id="rbLowEnergyRarely" name="rbLowEnergy" className="add-only" value="Rarely" />&nbsp;
                            2
                        </td>
                        <td className="w-100 text-center">
                            <input type="radio" id="rbLowEnergySometimes" name="rbLowEnergy" className="add-only" value="Sometimes" />&nbsp;
                            3
                        </td>
                        <td className="w-60 text-center">
                            <input type="radio" id="rbLowEnergyOften" name="rbLowEnergy" className="add-only" value="Often" />&nbsp;
                            4
                        </td>
                        <td className="w-60 text-center">
                            <input type="radio" id="rbLowEnergyAlways" name="rbLowEnergy" className="add-only" value="Always" />&nbsp;
                            5
                        </td>
                        <td className="w-100 text-center">
                            <input type="text" id="txtItemScore_LowEnergy" name="txtItemScore_LowEnergy" />
                        </td>
                    </tr>
                    <tr>
                        <td className="w-300"><b>15.</b> Trouble sleeping</td>
                        <td className="w-60 text-center">
                            <input type="radio" id="rbTroubleSleepingNever" name="rbTroubleSleeping" className="add-only" value="Never" />&nbsp;
                            1
                        </td>
                        <td className="w-60 text-center">
                            <input type="radio" id="rbTroubleSleepingRarely" name="rbTroubleSleeping" className="add-only" value="Rarely" />&nbsp;
                            2
                        </td>
                        <td className="w-100 text-center">
                            <input type="radio" id="rbTroubleSleepingSometimes" name="rbTroubleSleeping" className="add-only" value="Sometimes" />&nbsp;
                            3
                        </td>
                        <td className="w-60 text-center">
                            <input type="radio" id="rbTroubleSleepingOften" name="rbTroubleSleeping" className="add-only" value="Often" />&nbsp;
                            4
                        </td>
                        <td className="w-60 text-center">
                            <input type="radio" id="rbTroubleSleepingAlways" name="rbTroubleSleeping" className="add-only" value="Always" />&nbsp;
                            5
                        </td>
                        <td className="w-100 text-center">
                            <input type="text" id="txtItemScore_TroubleSleeping" name="txtItemScore_TroubleSleeping" />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className="w-250 text-center">
                            <span className="eleHeader">Total/Partial Raw Score:</span>
                            <input type="text" name="txtRawScore" id="txtRawScore" className="add-only" />
                        </td>
                        <td className="w-500 text-center">
                            <span className="eleHeader">Prorated Total Raw Score: (if 1-3 items left unanswered)
                            </span>
                            <input type="text" name="txtRawScore1" id="txtRawScore1" className="add-only" />
                        </td>
                    </tr>
                </table>
                <p>
                    <strong>Instructions to Clinicians</strong>
                </p>
                <p>
                    The DSM-5 Level 2-Somatic Symptom-Adult measure is an adaptation of the 15-item Patient Health
                    Questionnaire Physical Symptoms (PHQ-15) that assesses the domain of somatic symptoms. The measure is
                    completed by the individual (or his or her informant) prior to a visit with the clinician. If the individual is of
                    impaired capacity and unable to complete the form (e.g., an individual with dementia), a knowledgeable
                    informant may complete the measure. Each item asks the individual (or informant) to rate the severity of the
                    individual's somatic symptom <strong>during the past 7 days.</strong>
                </p>
                <p>
                    <strong>Scoring and Interpretation</strong>
                </p>
                <p>
                    Each item on the PHQ-15 is rated on a 3-point scale (0=not bothered at all; 1=bothered a little; 2=bothered a
                    lot). The total score can range from 0 to 30, with higher scores indicating greater severity of somatic
                    symptoms. The clinician is asked review the score of each item on the measure during the clinical interview
                    and indicate the raw score for each item in the section provided for "Clinician Use." The raw scores on the 15
                    items should be summed to obtain a total raw score and interpreted using the Interpretation Table for the
                    PHQ-15 Somatic Symptom Severity scale below:
                </p>
                <p>
                    <strong>Interpretation Table for the PHQ-15 Somatic Symptom Severity scale</strong>
                </p>
                <table>
                    <tr>
                        <td className="w-375">
                            <strong>Levels of Somatic Symptom Severity</strong>
                        </td>
                        <td className="w-375">
                            <strong>PHQ-15 Score</strong>
                        </td>
                    </tr>
                    <tr>
                        <td className="w-375">Minimal
                        </td>
                        <td className="w-375">0-4
                        </td>
                    </tr>
                    <tr>
                        <td className="w-375">Low
                        </td>
                        <td className="w-375">5-9
                        </td>
                    </tr>
                    <tr>
                        <td className="w-375">Medium
                        </td>
                        <td className="w-375">10-14
                        </td>
                    </tr>
                    <tr>
                        <td className="w-375">High
                        </td>
                        <td className="w-375">15-30
                        </td>
                    </tr>
                </table>
                <p>
                    <strong>Note:</strong> If 4 or more items are left unanswered on the PHQ-15 (i.e., more than 25% of the total items are
                    missing) the total score should not be calculated. As such, the individual (or informant) should be encouraged
                    to complete all of the items on the measure. If 1 to 3 items are left unanswered, you should prorate the raw
                    score by first summing scores of items that were answered to get a <strong>partial raw score.</strong> Next, multiply the
                    partial raw score by the total number of items on the measure (i.e., 15). Finally, divide the value by the
                    number of items that were actually answered to obtain the prorated total raw score.
                </p>
               <p>
                       <b> Prorated Score = </b>(Partial Raw Score x number of items on the PHQ-15)/Number of items that were actually answered
                    </p>
       
                <p>
                    If the result is a fraction, round to the nearest whole number.
                </p>
                <p>
                    The prorated total raw score should be interpreted using the Interpretation Table for the PHQ-15 Somatic
                    Symptom Severity scale above.
                </p>
                <p>
                    <strong>Frequency of Use</strong>
                </p>
                <p>
                    To track change in the severity of the individual's somatic symptom over time, the measure may be completed
                    at regular intervals as clinically indicated, depending on the stability of the individual's symptoms and
                    treatment status. For an individual of impaired capacity, it is preferred that completion of the measure at
                    follow-up appointments is by the same knowledgeable informant. Consistently high scores on a particular
                    domain may indicate significant and problematic areas for the patient that might warrant further assessment,
                    treatment, and follow-up. Your clinical judgment should guide your decision.
                </p>
            </div>
        </form>
    )
}